import { Input, Select, DatePicker } from 'element-ui'

const elEnum = {
  input: Input,
  select: Select,
  datePicker: DatePicker,
}

export default {
  name: 'TableFilter',

  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      elEnum,
      filterList: [],
    }
  },

  created() {
    // console.log(this.list);
  },

  computed: {
    // filterList({ list }) {
    //   return list.map((item) => {
    //     return {
    //       ...item,
    //       value: item.value === undefined ? '' : item.value,
    //     };
    //   });
    // },

    filterdData({ filterList }) {
      const result = {}
      filterList
        .filter((item) => {
          if (item.value === undefined || item.value === null || item.value === '') {
            return false
          }

          if (Array.isArray(item.value) && item.value.length === 0) {
            return false
          }

          return item
        })
        .forEach((item) => {
          const { type, prop, value } = item
          if (type === 'datePicker') {
            const { props } = item
            for (let i = 0; i < props.length; i += 1) {
              result[props[i]] = value[i]
            }
          } else {
            result[prop] = value
          }
        })

      return result
    },
  },

  methods: {
    search() {
      this.$emit('trigger', this.filterdData)
    },

    getFilterData() {
      return { ...this.filterdData }
    },

    setValue(prop, value) {
      const target = this.filterList.find((item) => item.prop === prop)
      if (!target) return
      target.value = value
    },
  },

  watch: {
    list: {
      handler(val) {
        if (!val || !val.length) return
        this.filterList = val.map((item) => {
          return {
            ...item,
            value: item.value === undefined ? '' : item.value,
          }
        })
      },
      immediate: true,
    },
  },
}
